import Renderer from "./Renderer.js";
import moment from "moment";

class TimeRenderer extends Renderer {
    render() {
        if (!this.data) {
            return '';
        }
        return moment(this.data, 'HH:mm:ss').format('HH:mm')
    }
}

export default TimeRenderer;
